import api from './api';

const departmentService = {
  // ============================================
  // USER: Get my departments
  // ============================================
  getMyDepartments: async () => {
    const response = await api.get('/departments/my');
    return response.data;
  },

  // ============================================
  // USER: Get files in a department
  // ============================================
  getDepartmentFiles: async (departmentId, search = '') => {
    const params = {};
    if (search) params.search = search;
    const response = await api.get(`/departments/${departmentId}/files`, { params });
    return response.data;
  },

  // ============================================
  // USER: Download department file
  // ============================================
  downloadDepartmentFile: async (departmentId, fileId, fileName) => {
    const response = await api.get(
      `/departments/${departmentId}/files/${fileId}/download`,
      { responseType: 'blob' }
    );
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  },

  // ============================================
  // USER: Get preview URL for department file
  // ============================================
  getPreviewUrl: (departmentId, fileId) => {
    const token = localStorage.getItem('token');
    const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';
    return `${baseURL}/departments/${departmentId}/files/${fileId}/preview?token=${token}`;
  },

  // ============================================
  // ADMIN: Get all departments
  // ============================================
  getAllDepartments: async () => {
    const response = await api.get('/departments');
    return response.data;
  },

  // ============================================
  // ADMIN: Create department
  // ============================================
  createDepartment: async (name, description) => {
    const response = await api.post('/departments', { name, description });
    return response.data;
  },

  // ============================================
  // ADMIN: Update department
  // ============================================
  updateDepartment: async (id, name, description) => {
    const response = await api.put(`/departments/${id}`, { name, description });
    return response.data;
  },

  // ============================================
  // ADMIN: Delete department
  // ============================================
  deleteDepartment: async (id) => {
    const response = await api.delete(`/departments/${id}`);
    return response.data;
  },

  // ============================================
  // ADMIN: Get department members
  // ============================================
  getMembers: async (departmentId) => {
    const response = await api.get(`/departments/${departmentId}/members`);
    return response.data;
  },

  // ============================================
  // ADMIN: Add member to department
  // ============================================
  addMember: async (departmentId, userId) => {
    const response = await api.post(`/departments/${departmentId}/members`, { user_id: userId });
    return response.data;
  },

  // ============================================
  // ADMIN: Remove member from department
  // ============================================
  removeMember: async (departmentId, userId) => {
    const response = await api.delete(`/departments/${departmentId}/members/${userId}`);
    return response.data;
  },
};

export default departmentService;
